var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v("Step 4 of 9: Goals"),
        ]),
        _c("div", { staticClass: "grid grid-cols-1 gap-3" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Type "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "nutrition_goals_type",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("nutrition_goals_type", val),
                    },
                    model: {
                      value: _vm.localFormData.nutrition_goals_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "nutrition_goals_type", $$v)
                      },
                      expression: "localFormData.nutrition_goals_type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Description "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "nutrition_goals_description",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("nutrition_goals_description", val),
                    },
                    model: {
                      value: _vm.localFormData.nutrition_goals_description,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "nutrition_goals_description",
                          $$v
                        )
                      },
                      expression: "localFormData.nutrition_goals_description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Related Diagnosis "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "nutrition_goals_diagnosis",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("nutrition_goals_diagnosis", val),
                    },
                    model: {
                      value: _vm.localFormData.nutrition_goals_diagnosis,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "nutrition_goals_diagnosis",
                          $$v
                        )
                      },
                      expression: "localFormData.nutrition_goals_diagnosis",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(1),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Timing Requirements "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "medication_goals_timing",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("medication_goals_timing", val),
                    },
                    model: {
                      value: _vm.localFormData.medication_goals_timing,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "medication_goals_timing",
                          $$v
                        )
                      },
                      expression: "localFormData.medication_goals_timing",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Supervision Needed "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "medication_goals_supervision",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("medication_goals_supervision", val),
                    },
                    model: {
                      value: _vm.localFormData.medication_goals_supervision,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "medication_goals_supervision",
                          $$v
                        )
                      },
                      expression: "localFormData.medication_goals_supervision",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(2),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Hygiene Goals "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "personal_goals_hygiene",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("personal_goals_hygiene", val),
                    },
                    model: {
                      value: _vm.localFormData.personal_goals_hygiene,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "personal_goals_hygiene",
                          $$v
                        )
                      },
                      expression: "localFormData.personal_goals_hygiene",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Self-Care Support "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "personal_goals_self_care",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("personal_goals_self_care", val),
                    },
                    model: {
                      value: _vm.localFormData.personal_goals_self_care,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "personal_goals_self_care",
                          $$v
                        )
                      },
                      expression: "localFormData.personal_goals_self_care",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(3),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Wound Monitering "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "skin_goals_wound",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("skin_goals_wound", val),
                    },
                    model: {
                      value: _vm.localFormData.skin_goals_wound,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "skin_goals_wound", $$v)
                      },
                      expression: "localFormData.skin_goals_wound",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Change Reporting "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "skin_goals_reporting",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("skin_goals_reporting", val),
                    },
                    model: {
                      value: _vm.localFormData.skin_goals_reporting,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "skin_goals_reporting", $$v)
                      },
                      expression: "localFormData.skin_goals_reporting",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("General Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "skin_goals_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("skin_goals_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.skin_goals_notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "skin_goals_notes", $$v)
                      },
                      expression: "localFormData.skin_goals_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Dietary/Nutrition Goals"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Medication Goals"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Personal Care Goals"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Skin Integrity Goals"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }